{
  "title": "بيانات المؤسسة",
  "description": "اسم المؤسسة وشعارها كما يظهران على شاشة انتظار جهاز التابلت.",
  "fields": {
    "nameAr": "اسم المؤسسة بالعربية",
    "nameEn": "اسم المؤسسة بالإنجليزية"
  },
  "save": "حفظ",
  "saved": "تم تحديث بيانات المؤسسة بنجاح",
  "logo": {
    "label": "الشعار",
    "choose": "اختيار صورة",
    "remove": "حذف الشعار",
    "none": "لا يوجد شعار",
    "hint": "صورة PNG أو JPEG بحجم 512 كيلوبايت كحد أقصى",
    "invalid": "اختر صورة PNG أو JPEG بحجم 512 كيلوبايت كحد أقصى",
    "uploading": "جاري رفع الشعار...",
    "uploaded": "تم تحديث الشعار بنجاح",
    "removed": "تم حذف الشعار بنجاح",
    "removeConfirmTitle": "حذف الشعار؟",
    "removeConfirmDescription": "ستظهر شاشة انتظار جهاز التابلت دون شعار.",
    "alt": "شعار {{name}}"
  }
}
